import React from "react";

import logo from "@/assets/images/minimarlogo.png";
import bd_logo from "@/assets/images/bdlogo.png";
import bard_logo from "@/assets/images/bardlogo.png";

interface MinimarLogoProps {
  size?: "header" | "small" | "medium" | "large"; // Opsiyonel size prop
  logo_name?: "minimar" | "bd" | "bard" // Opsiyonel logo_name prop
}

const MinimarLogo: React.FC<MinimarLogoProps> = ({ size = "medium", logo_name = "minimar" }) => {
  // Size'lara göre width değerleri
  const sizeMap = {
    header: 125,
    small: 150,
    medium: 200,
    large: 250,
  };

  // Seçilen size'ın width değeri
  const width = sizeMap[size || "medium"];

  return (
    <div>
      <img
        src={
          logo_name === "minimar"
            ? logo
            : logo_name === "bd"
              ? bd_logo
              : bard_logo
        }
        alt={logo_name === "minimar" ? "Minimar Logo" : logo_name === "bd" ? "BD Logo" : "Bard Logo"}
        style={{ width: `${width}px`, height: "auto" }}
      />
    </div>
  );
};

export default MinimarLogo;
